import { render, staticRenderFns } from "./downloadTender.vue?vue&type=template&id=7087e343&scoped=true"
import script from "./downloadTender.vue?vue&type=script&lang=js"
export * from "./downloadTender.vue?vue&type=script&lang=js"
import style0 from "./downloadTender.vue?vue&type=style&index=0&id=7087e343&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7087e343",
  null
  
)

export default component.exports